import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { ThemeContext } from './BrandStore/context/ThemeContext';

import './BrandStore/styles/slick-theme.min.css';
import './BrandStore/styles/slick.min.css';
import './BrandStore/styles/reset.css';
import './BrandStore/styles/common.css';

ReactDOM.render(
  <React.StrictMode>
    <ThemeContext.Provider value="primary">
    <App />
    </ThemeContext.Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

